import { AccountModel, MeasureUnit, UserModel, UserStatus } from '@truckdown/accounts';
import context, { ILookupService, ServiceLookupModel, ServiceModel, ServiceStatus, ServiceType } from '@truckdown/systems';
import { defineComponent, ref, Ref, onMounted } from 'vue';
import { isCsrOrAdmin, isFleet, isGeneralAdmin } from "../Utilities/Utilities";

interface IData {
    isLoading: Ref<boolean>,
}

const getInitialData = function (props: any) {
    return {
        isLoading: ref<boolean>(false),
    } as IData;
}

const getMethods = function (data: IData, props: any) {
    return {

    }
}


export default defineComponent({
    name: "EditAccountAdmin",
    props: {
        account: {
            type: Object as () => AccountModel,
            required: true
        }
    },
    setup: function (props, ctx: any) {
        let data = getInitialData(props);
        let methods = getMethods(data, props);

        return {
            ...data,
            ...methods,

        }
    }
})